export default __webpack_public_path__ + "static/media/userIcon.2c2f382a.svg";